module.exports = DateTimeFormat =
  RFC2822: 'ddd, DD MMM YYYY HH:mm:ss ZZ'
  Admin: 'ddd, DD MMM YYYY'
  AdminWithTime: 'ddd, DD MMM YYYY HH:mm'
  Short: 'LLL'
  Simple: 'll'
  Long: 'llll'
